<template>
  <ib-dialog
    :visible="visible"
    :fullscreen="true"
    @close="close"
  >
    <ib-dialog-container max-width="940px">

      <!-- Header -->
      <intro-header
        :chapter="1"
        :image="require('@/assets/img/business-guide/icon-concept.svg')"
        :title="$t('dialogs.concept.concept')"
        :subtitle="$t('dialogs.concept.soYouHadAha')"
        :description="$t('dialogs.concept.conceptChapterWillHelpYou')"
      />
      <!-- /Header -->

      <!-- Divider -->
      <intro-divider />
      <!-- /Divider -->

      <!-- Inner Wrapper -->
      <div class="inner-wrapper mb-5">
        <!-- Step 1 -->
        <el-row :gutter="60" class="d-flex flex-column flex-sm-row align-items-center py-4">
          <el-col :md="12" class="mb-4 mb-sm-0 ">
            <ib-pill text-uppercase>
              {{ $t('stepNumber', {number: 1}) }}
            </ib-pill>
            <intro-step-info
              :title="$t('dialogs.concept.idea.idea')"
              :description="$t('dialogs.concept.idea.startByExplaining')"
            >
              <!--              <ul>-->
              <!--                <li>{{ $t('dialogs.concept.idea.isThereMarketProblem') }}</li>-->
              <!--                <li>{{ $t('dialogs.concept.idea.whatIsTheBrilliantSolution') }}</li>-->
              <!--              </ul>-->

              <ib-button-basic
                color="blue" class="my-4"
                @click="$router.push({name: 'business-guide-concept-idea'})"
              >
                {{ $t('startHere') }}
              </ib-button-basic>
            </intro-step-info>
          </el-col>
          <el-col :md="12">
            <div class="concept-steps-image-wrapper d-flex justify-content-center">
              <img src="@/assets/img/icons/tutorials/concept/step1.png" alt="">
            </div>
          </el-col>
        </el-row>
        <!-- /Step 1 -->

        <!-- Divider -->
        <intro-divider />
        <!-- /Divider -->

        <!-- Step 2 -->
        <el-row :gutter="60" class="d-flex flex-column flex-sm-row-reverse align-items-center py-4">
          <el-col :md="12" class="mb-4 mb-sm-0">
            <ib-pill text-uppercase>
              {{ $t('stepNumber', {number: 2}) }}
            </ib-pill>
            <intro-step-info
              :title="$t('dialogs.concept.product.product')"
              :description="$t('dialogs.concept.product.defineTheProductAndServices')"
            >
              <ib-button-basic
                color="blue" class="my-4"
                @click="$router.push({name: 'business-guide-concept-product'})"
              >
                {{ $t('startHere') }}
              </ib-button-basic>
            </intro-step-info>
          </el-col>
          <el-col :md="12">
            <div class="concept-steps-image-wrapper d-flex justify-content-center">
              <img src="@/assets/img/icons/tutorials/concept/step2.png" alt="">
            </div>
          </el-col>
        </el-row>
        <!-- /Step 2 -->

        <!-- Divider -->
        <intro-divider />
        <!-- /Divider -->

        <!-- Step 3 -->
        <el-row :gutter="60" class="d-flex flex-column flex-sm-row align-items-center py-4">
          <el-col :md="12" class="mb-4 mb-sm-0">
            <ib-pill text-uppercase>
              {{ $t('stepNumber', {number: 3}) }}
            </ib-pill>
            <intro-step-info
              :title="$t('dialogs.concept.promotion.promotion')"
              :description="$t('dialogs.concept.promotion.explainHowWillPeopleFind')"
            >
              <ib-button-basic
                color="blue" class="my-4"
                @click="$router.push({name: 'business-guide-concept-promotion'})"
              >
                {{ $t('startHere') }}
              </ib-button-basic>
            </intro-step-info>
          </el-col>
          <el-col :md="12">
            <div class="concept-steps-image-wrapper d-flex justify-content-center">
              <img src="@/assets/img/icons/tutorials/concept/step3.png" alt="">
            </div>
          </el-col>
        </el-row>
        <!-- /Step 3 -->

        <!-- Divider -->
        <intro-divider />
        <!-- /Divider -->

        <!-- Step 4 -->
        <el-row :gutter="60" class="d-flex flex-column flex-sm-row-reverse align-items-center py-4">
          <el-col :md="12" class="mb-4 mb-sm-0">
            <ib-pill text-uppercase>
              {{ $t('stepNumber', {number: 4}) }}
            </ib-pill>
            <intro-step-info
              :title="$t('dialogs.concept.distribution.distribution')"
              :description="$t('dialogs.concept.distribution.defineHowDoYouPlan')"
            >
              <ib-button-basic
                color="blue" class="my-4"
                @click="$router.push({name: 'business-guide-concept-distribution'})"
              >
                {{ $t('startHere') }}
              </ib-button-basic>
            </intro-step-info>
          </el-col>
          <el-col :md="12">
            <div class="concept-steps-image-wrapper d-flex justify-content-center">
              <img src="@/assets/img/icons/tutorials/concept/step4.png" alt="">
            </div>
          </el-col>
        </el-row>
        <!-- /Step 4 -->

        <!-- Divider -->
        <intro-divider />
        <!-- /Divider -->

        <!-- Step 5 -->
        <el-row :gutter="60" class="d-flex flex-column flex-sm-row align-items-center py-4">
          <el-col :md="12" class="mb-4 mb-sm-0">
            <ib-pill text-uppercase>
              {{ $t('stepNumber', {number: 5}) }}
            </ib-pill>
            <intro-step-info
              :title="$t('dialogs.concept.partners.partners')"
              :description="$t('dialogs.concept.partners.describeTheRelationship')"
            >
              <ib-button-basic
                color="blue" class="my-4"
                @click="$router.push({name: 'business-guide-concept-partners'})"
              >
                {{ $t('startHere') }}
              </ib-button-basic>
            </intro-step-info>
          </el-col>
          <el-col :md="12">
            <div class="concept-steps-image-wrapper d-flex justify-content-center">
              <img src="@/assets/img/icons/tutorials/concept/step5.png" alt="">
            </div>
          </el-col>
        </el-row>
        <!-- /Step 5 -->

        <!--        &lt;!&ndash; Divider &ndash;&gt;-->
        <!--        <intro-divider />-->
        <!--        &lt;!&ndash; /Divider &ndash;&gt;-->

        <!--        &lt;!&ndash; Step 6 &ndash;&gt;-->
        <!--        <el-row :gutter="60" class="o-50 d-flex flex-column flex-sm-row-reverse align-items-center">-->
        <!--          <el-col :md="12" class="mb-4 mb-sm-0">-->
        <!--            <ib-pill text-uppercase>-->
        <!--              {{ $t('dialogs.concept.conceptTesting.comingSoon') }}-->
        <!--            </ib-pill>-->
        <!--            <intro-step-info-->
        <!--              :title="$t('dialogs.concept.conceptTesting.conceptTesting')"-->
        <!--              :description="$t('dialogs.concept.conceptTesting.evaluateIdeaBySharing')"-->
        <!--            />-->
        <!--          </el-col>-->
        <!--          <el-col :md="12">-->
        <!--            <img class="mw-100" src="@/assets/img/icons/tutorials/concept/step6.png" alt="">-->
        <!--          </el-col>-->
        <!--        </el-row>-->
        <!--        &lt;!&ndash; /Step 6 &ndash;&gt;-->

        <!-- Divider -->
        <intro-divider />
        <!-- /Divider -->

        <!-- Dialog Bottom -->
        <intro-footer
          :btn-text="$t('dialogs.concept.startWithIdeaSection')"
          @click="onStart"
        />
        <!-- /Dialog Bottom -->

      </div>
      <!-- /Inner Wrapper -->

    </ib-dialog-container>
  </ib-dialog>
</template>

<script>
import IntroDivider from './Components/IntroDivider'
import IntroFooter from './Components/IntroFooter'
import IntroHeader from './Components/IntroHeader'
import IntroStepInfo from './Components/IntroStepInfo'

export default {
  name: 'IntroConcept',

  components: {
    IntroDivider,
    IntroHeader,
    IntroFooter,
    IntroStepInfo
  },

  props: {
    visible: Boolean
  },

  methods: {
    close () {
      this.$emit('close')
    },

    onStart () {
      this.$router.push({ name: 'business-guide-concept-idea' })

      this.$gtm.trackEvent({
        event: 'conceptCTA'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.concept-steps-image-wrapper {
  img {
    max-width: 80%;
  }
}

</style>
